module.exports = {
    "crude": {
        "search": "Søke",
        "actions": "Handlinger",
        "nextPage": "Neste side",
        "lastPage": "Forrige side",
        "back": "Tilbake",
        "empty": "tømme",
        "edit": "redigere",
        "create": "skape",
        "data": "ta opp",
        "view": "forestilling",
        "delete": "Slett",
        "save": "Lagre",
        "cancel": "Avbryt",
        "noContent": "Ingen oppføringer tilgjengelig. ",
        "resetFilter": "Tilbakestill filtrene og se mer innhold!",
        "createOwnTextField": "Lag ditt eget tekstfelt",
        "textFieldName": "tekstfeltetikett",
        "textFieldValue": "Innhold",
        "insertTextFieldLabel": "Vennligst skriv inn tekstfeltnavnet!",
        "deleteTextField": "Slett tekstfeltet",
        "success": "Lagring var vellykket",
        "invalidDataFields": "Følgende datafelt er ugyldige:  ",
        "entries": "innganger",
        "entry": "inngang",
        "tabDetail": "detaljer",
        "entity": "enhet",
        "of": "fra",
        "uploadNewFile": "Last opp fil",
        "upload": "laste opp",
        "confirm": "OK",
        "deleteFileQuestion": "Vil du virkelig slette denne filen? ",
        "deleteFileQuestionTitle": "Fare!",
        "deleteEntityQuestion": "Vil du virkelig slette denne enheten? ",
        "deleteEntityQuestionTitle": "Fare!",
        "errorLargeFileUpload": "Den valgte filen er for stor!",
        "useCroppedImage": "Bruk beskjæring",
        "useOriginalImage": "Bruk originalbildet",
        "available": "tilgjengelig",
        "searchColumn": "finn kolonne",
        "manageColumns": "Administrer kolonner",
        "hideColumn": "skjul kolonne",
        "pinToRight": "Fest kolonnen til høyre",
        "pinToLeft": "Fest kolonne til venstre",
        "sortAsc": "Sorter stigende",
        "sortDesc": "Sorter synkende",
        "hideAll": "skjule alt",
        "showAll": "Vis alt",
        "preview": "forhåndsvisning",
        "title": "tittel",
        "description": "Beskrivelse",
        "tooltip": "verktøytips",
        "sort": "Sorter etter",
        "settings": "Innstillinger",
        "incomingReference": "henvisning",
        "language": "Språk",
        "deleteTabQuestionTitle": "Fare!",
        "deleteTabQuestion": "Vil du virkelig slette denne fanen? ",
        "deleteElementQuestionTitle": "Fare!",
        "deleteElementQuestion": "Vil du virkelig slette dette elementet? ",
        "configurationEditorDescriptionStringLayout": "I denne kolonnen kan tre varianter velges for å skrive inn teksten:",
        "configurationEditorDescriptionEnumLayout": "To varianter kan velges for valg av elementene i denne kolonnen:",
        "configurationEditorDescriptionBooleanLayout": "To varianter kan velges for valg av elementene i denne kolonnen:",
        "configurationEditorDescriptionForeignEntityLayout": "To varianter kan velges for valg av elementene i denne kolonnen:",
        "stringLayoutsingleline": "enkel linje",
        "stringLayoutmultiline": "flerlinjet",
        "stringLayouteditor": "Rich Text Editor",
        "enumLayoutradio": "radioknapp",
        "enumLayoutdropdown": "fall ned",
        "booleanLayoutcheckbox": "avkrysningsboksen",
        "booleanLayoutswitch": "brytere",
        "foreignEntityLayoutpopUp": "popup",
        "foreignEntityLayoutautocomplete": "fall ned",
        "foreignEntityLayoutlist": "liste",
        "formatTooltipbold": "fett",
        "formatTooltipitalic": "kursiv",
        "formatTooltipunderline": "understreket",
        "formatTooltipstrike": "Krysset ut",
        "formatTooltipclean": "klar formatering",
        "formatTooltipcodeBlock": "kode",
        "formatTooltipblockquote": "Sitat",
        "formatTooltipcolor": "skriftfarge",
        "formatTooltipbackground": "bakgrunnsfarge",
        "formatTooltipfont": "font",
        "formatTooltipalign": "Justering",
        "formatTooltipheader": "skriftstørrelse",
        "formatTooltipsuper": "Overskrift",
        "formatTooltipsub": "abonnement",
        "formatTooltipordered": "Bestilt liste",
        "formatTooltipbullet": "Oppregning",
        "true": "Ja",
        "false": "Nei",
        "selectEntity": "velg enhet",
        "filter": "filter",
        "useFilter": "Bruk filtre",
        "defaultFilter": "tilbakestill filteret",
        "expand": "utvide",
        "hide": "gjemme seg",
        "minimumSelectionError": "Minst {{min}} oppføringer må velges.",
        "maximumSelectionError": "Maksimalt {{max}} oppføringer kan velges."
    }
}
;